import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app.component';
import { APP_PROVIDERS } from './app/app-providers';

const options = { providers: APP_PROVIDERS };
bootstrapApplication(AppComponent, options).catch(console.error);
